export default __webpack_public_path__ + "static/media/lab.b36e0fd8.jpg";